"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Autocomplete = _interopRequireWildcard(require("@material-ui/lab/Autocomplete"));

var _styles = require("@material-ui/core/styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const filter = (0, _Autocomplete.createFilterOptions)();
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    "& .MuiFormLabel-root": {
      fontFamily: "Akkurat, sans-serif"
    },
    "& .MuiInputBase-root": {
      fontFamily: "Akkurat, sans-serif",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(1)
    },
    "& .MuiFormLabel-root": {
      fontFamily: "Akkurat, sans-serif"
    },
    "& .MuiAutocomplete-inputRoot[class*=MuiFilledInput-root] .MuiAutocomplete-input": {
      padding: theme.spacing(.25, .5)
    },
    "& .MuiAutocomplete-tag": {
      margin: theme.spacing(.25)
    }
  }
}));

const TagsChip = (_ref) => {
  let label = _ref.label,
      disabled = _ref.disabled,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "disabled"]);

  const classes = useStyles();

  if (disabled) {
    return _react.default.createElement(_Chip.default, {
      className: classes.chip,
      variant: "outlined",
      size: "small",
      label: label
    });
  }

  return _react.default.createElement(_Chip.default, _extends({
    className: classes.chip,
    variant: "outlined",
    size: "small",
    label: label
  }, props));
};

const TagsField = (_ref2) => {
  let id = _ref2.id,
      disabled = _ref2.disabled,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? "Tags" : _ref2$label,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? [] : _ref2$value,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? "Add tag" : _ref2$placeholder,
      helperText = _ref2.helperText,
      onChange = _ref2.onChange,
      props = _objectWithoutPropertiesLoose(_ref2, ["id", "disabled", "label", "value", "options", "placeholder", "helperText", "onChange"]);

  const classes = useStyles();

  const renderTags = (value, getTagProps) => {
    return value.map((option, index) => _react.default.createElement(TagsChip, _extends({
      label: option,
      disabled: disabled
    }, getTagProps({
      index
    }))));
  };

  const handleChange = (event, value, reason) => {
    const tags = value.map(option => {
      return getOptionLabel(option).toLowerCase();
    });
    onChange && onChange(tags);
  };

  const filterOptions = (options, params) => {
    const filtered = filter(options, params); // Suggest the creation of a new value

    if (params.inputValue !== '') {
      filtered.push({
        value: params.inputValue,
        label: "+ \"" + params.inputValue + "\""
      });
    }

    return filtered;
  };

  const getOptionLabel = option => {
    // Value selected with enter, right from the input
    if (typeof option === 'string') {
      return option;
    } // Regular option


    return option.value;
  };

  const renderOption = option => {
    if (typeof option === 'string') {
      return option;
    }

    return option.label;
  };

  return _react.default.createElement(_Autocomplete.default, {
    className: classes.root,
    multiple: true,
    id: id,
    options: options,
    disabled: disabled,
    filterOptions: filterOptions,
    getOptionLabel: getOptionLabel,
    renderOption: renderOption,
    value: value,
    freeSolo: true,
    renderTags: renderTags,
    renderInput: params => _react.default.createElement(_TextField.default, _extends({}, params, {
      className: classes.input,
      variant: "filled",
      label: label,
      placeholder: placeholder,
      helperText: helperText
    })),
    onChange: handleChange
  });
};

var _default = TagsField;
exports.default = _default;
module.exports = exports.default;